import request from "../helpers/request";
import {createRestfulApi} from "./createRestfulApi";

const URL = {
    // 素材管理
    SEARCHMATERIALRESOURCE: "materialManager/searchMaterialResource",
    SAVEMATERIALRESOURCE: "materialManager/saveMaterialResource",
    DELETEMATERIALRESOURCE: "materialManager/deleteMaterialResource",
    SEARCHDISEASE: "disease/searchDisease",
    SAVEDISEASE: "disease/saveDisease",
    DELETEDISEASE: "disease/deleteDisease",

    GETCLASSSUBJECTEDITLIST: "classSubject/getClassSubjectEditList",
    GETLESSONRESPONSELIST: "lesson/getLessonResponseList",
    // 获取用户可见的单位，企业用户能看见所有单位，一定包含企业
    GETUSERDEPARTMENTDICTIONARY: "user/getUserDepartmentDictionary",
    MOVELESSONRESPONSELIST: "lesson/moveLessonResponseList",
    DELETELESSONFORVERSION: "lesson/deleteLessonForVersion",
    DELETE_LESSON: "lesson/deleteLesson",
    SAVELESSON: "lesson/saveLesson",
    INIT_LESSON_VERSION: "lesson/initLessonVersion",
    COPYLESSON: "lesson/copyLesson",
    MOVE_LESSON: "lesson/moveLesson",

    // 默认配置中的大纲
    GETUSERCONFIG: "userConfig/getUserConfig",
    SAVEUSERCONFIG: "userConfig/saveUserConfig",
    // 根据lessonId获取大纲
    GETLESSONEDITOUTLINE: "lesson/getLessonEditOutline",
    // 生成课程大纲
    SAVELESSONVERSION: "lesson/saveLessonVersion",
    //我的大纲下的课程内容
    // GETLESSONCONTENT: "lesson/getLessonContent",
    GETLESSONCONTENT: "lesson/getLessonContentByGroupModelId",
    //文字转语音上传地址
    GETAUDIOURL: "oss/generalAudioByText",
    //保存课程内容
    SAVELESSONCONTENT: "lesson/saveLessonContent",
    //下方添加
    ADDBELOWLESSONCONTENT: "lesson/addBelowLessonContent",
    //删除课程内容
    DELETELESSONCONTENT: "lesson/deleteLessonContent",
    //课程内容的上移、下移
    MOVELESSONCONTENT: "lesson/moveLessonContentResponseList",
    //提交课程版本
    SUBMITLESSONVERSION: "lesson/submitLessonVersion",

    // 知识点搜索
    MATCHTITLE: "disease/matchTitle",
    MATCHCONTENT: "disease/matchContent",

    // 获取知识点回顾列表
    GETLESSONPOINTREVIEWCONTENTLIST: "lesson/getLessonPointReviewContentList",
    SAVEPOINTREVIEWCONTENT: "lesson/savePointReviewContent",
    DELETEPOINTREVIEWCONTENT: "lesson/deletePointReviewContent",

    // 问题管理
    GETQUESTIONRESPONSELIST: "lesson/getLessonQuestionResponseList",
    SAVELESSONQUESTION: "lesson/saveLessonQuestion",
    RECOMMENDLESSONQUESTION: "lesson/recommendLessonQuestion",

    // 标签管理
    GETTAGLIST: "tag/getTagCategoryList",

    // 未读懂管理
    GETMARKRESPONSELIST: "lesson/getLessonMarkList",
};

export default {
    searchMaterialResource({keyword, page, size, type}) {
        return request(URL.SEARCHMATERIALRESOURCE, "POST", {
            keyword,
            page,
            size,
            type,
        });
    },

    saveMaterialResource({id, filename, name, watermark, accessControl}) {
        return request(URL.SAVEMATERIALRESOURCE, "POST", {
            id,
            filename,
            name,
            watermark,
            accessControl,
        });
    },

    deleteMaterialResource({id, enable}) {
        return request(URL.DELETEMATERIALRESOURCE, "POST", {
            id,
            enable,
        });
    },

    searchDisease({keyword, type, page, size}) {
        return request(URL.SEARCHDISEASE, "POST", {
            keyword,
            type,
            page,
            size,
        });
    },

    saveDisease({id, title, content, createTime, userId, type}) {
        return request(URL.SAVEDISEASE, "POST", {
            id,
            title,
            content,
            createTime,
            userId,
            type,
        });
    },

    deleteDisease({id}) {
        return request(URL.DELETEDISEASE, "POST", {
            id,
        });
    },

    getClassSubjectEditList: createRestfulApi(URL.GETCLASSSUBJECTEDITLIST, {
        queryParams: [],
    }),
    getLessonResponseList: createRestfulApi(URL.GETLESSONRESPONSELIST, {
        queryParams: [],
    }),
    getUserDepartmentDictionary() {
        return request(URL.GETUSERDEPARTMENTDICTIONARY, "GET");
    },
    moveLessonResponseList({
                               classSubjectId,
                               endTime,
                               keyword,
                               offset,
                               previewDirect,
                               startTime,
                               states,
                               step,
                           }) {
        return request(URL.MOVELESSONRESPONSELIST, "POST", {
            classSubjectId,
            endTime,
            keyword,
            offset,
            previewDirect,
            startTime,
            states,
            step,
        });
    },
    deleteLessonForVersion({id}) {
        return request(URL.DELETELESSONFORVERSION, "POST", {
            id,
        });
    },
    deleteLesson({id}) {
        return request(URL.DELETE_LESSON, "POST", {
            id,
        });
    },
    getMatchTitle: createRestfulApi(URL.MATCHTITLE, {
        queryParams: [],
    }),
    getMatchContent: createRestfulApi(URL.MATCHCONTENT, {
        queryParams: [],
    }),
    copyLesson(lessonId, classSubjectId) {
        return request(URL.COPYLESSON, "POST", {lessonId, classSubjectId});
    },
    moveLesson(lessonId, classSubjectId) {
        return request(URL.MOVE_LESSON, "POST", {lessonId, classSubjectId});
    },
    saveLesson({
                   avatarId,
                   material,
                   classSubjectId,
                   id,
                   name,
                   nickname,
                   tagValueIdList,
                   target,
                   category,
               }) {
        return request(URL.SAVELESSON, "POST", {
            avatarId,
            material,
            classSubjectId,
            id,
            name,
            nickname,
            tagValueIdList,
            target,
            category,
        });
    },
    initLessonVersion({id}) {
        return request(URL.INIT_LESSON_VERSION, "POST", {id});
    },
    getUserConfig({type}) {
        return request(URL.GETUSERCONFIG, "GET", {
            type,
        });
    },
    saveUserConfig({data, type}) {
        return request(URL.SAVEUSERCONFIG, "POST", {
            data,
            type,
        });
    },
    getLessonEditOutline({id}) {
        return request(URL.GETLESSONEDITOUTLINE, "POST", {
            id,
        });
    },
    saveLessonVersion({id, lessonId, outline}) {
        return request(URL.SAVELESSONVERSION, "POST", {
            id,
            lessonId,
            outline,
        });
    },
    getLessonContent({lessonId, modelId, version}) {
        return request(URL.GETLESSONCONTENT, "POST", {
            lessonId,
            modelId,
            version,
        });
    },
    getAudioUrl({pitchRate, speechRate, text, voice, volume}) {
        return request(URL.GETAUDIOURL, "POST", {
            pitchRate,
            speechRate,
            text,
            voice,
            volume,
        });
    },
    saveLessonContent({
                          id,
                          lessonContentTemplate,
                          lessonId,
                          model,
                          modelId,
                          role,
                          type,
                          version,
                      }) {
        return request(URL.SAVELESSONCONTENT, "POST", {
            id,
            lessonContentTemplate,
            lessonId,
            model,
            modelId,
            role,
            type,
            version,
        });
    },
    addBelowLessonContent({
                              id,
                              lessonContentTemplate,
                              lessonId,
                              model,
                              modelId,
                              operateOffset,
                              role,
                              type,
                              version,
                          }) {
        return request(URL.ADDBELOWLESSONCONTENT, "POST", {
            id,
            lessonContentTemplate,
            lessonId,
            model,
            modelId,
            operateOffset,
            role,
            type,
            version,
        });
    },
    deleteLessonContent({id}) {
        return request(URL.DELETELESSONCONTENT, "POST", {
            id,
        });
    },
    moveLessonContent({
                          lessonId,
                          version,
                          modelId,
                          offset,
                          previewDirect,
                          step,
                      }) {
        return request(URL.MOVELESSONCONTENT, "POST", {
            lessonId,
            version,
            modelId,
            offset,
            previewDirect,
            step,
        });
    },
    submitLessonVersion({lessonId, version}) {
        return request(URL.SUBMITLESSONVERSION, "POST", {
            lessonId,
            version,
        });
    },
    getLessonPointReviewContentList({lessonId, version}) {
        return request(URL.GETLESSONPOINTREVIEWCONTENTLIST, "POST", {
            lessonId,
            version,
        });
    },
    savePointReviewContent({contents, lessonId, version}) {
        return request(URL.SAVEPOINTREVIEWCONTENT, "POST", {
            contents,
            lessonId,
            version,
        });
    },
    deletePointReviewContent({id}) {
        return request(URL.DELETEPOINTREVIEWCONTENT, "POST", {
            id,
        });
    },
    getLessonQuestionResponseList: createRestfulApi(URL.GETQUESTIONRESPONSELIST, {
        queryParams: [],
    }),
    getLessonMarkResponseList: createRestfulApi(URL.GETMARKRESPONSELIST, {
        queryParams: [],
    }),
    saveLessonQuestion({id, lessonId, answer}) {
        return request(URL.SAVELESSONQUESTION, "POST", {
            id,
            lessonId,
            answer,
        });
    },
    recommendLessonQuestion({id, openState}) {
        return request(URL.RECOMMENDLESSONQUESTION, "POST", {
            id,
            openState,
        });
    },
    getTagCategoryList({includeChild, page, size}) {
        return request(URL.GETTAGLIST, "POST", {
            includeChild,
            page,
            size,
        });
    },
};
